import { useEffect } from 'react';

const DEFAULT_TITLE = 'NorthBridge One';

/**
 * Sätter sidtitel och meta-beskrivning per vy. Version 1 är en SPA – när
 * organisk trafik blir viktigare bör sidorna prerenderas eller SSR:as.
 */
export function usePageMeta(title: string, description: string): void {
  useEffect(() => {
    document.title = `${title} | ${DEFAULT_TITLE}`;

    const meta = document.querySelector('meta[name="description"]');
    const previous = meta?.getAttribute('content') ?? '';
    meta?.setAttribute('content', description);

    return () => {
      meta?.setAttribute('content', previous);
    };
  }, [title, description]);
}
